export default "__VITE_ASSET__DuQeIBNq__"